import { render } from "./ProjectsContent.vue?vue&type=template&id=05596ff8"
import script from "./ProjectsContent.vue?vue&type=script&lang=js"
export * from "./ProjectsContent.vue?vue&type=script&lang=js"

import "./ProjectsContent.vue?vue&type=style&index=0&id=05596ff8&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__